import { classNames } from "../../shared/utility";
import DatePickerInput from "../controls/DatePickerInput";

export default function DateRangeFilter(props) {
  const {
    onChange,
    resetFilter,
    startDate,
    endDate,
    maxDate,
    hideTitle,
    showOneDate,
    startDateName,
    endDateName,
  } = props;

  return (
    <div className={hideTitle ? "" : "p-3"}>
      <div className={hideTitle ? "hidden" : "flex justify-between"}>
        <p className="text-sm text-gray-700 font-semibold">Date Range</p>
        <button
          onClick={() => resetFilter()}
          className="text-sm font-semibold main-purple"
        >
          Reset
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-1">
        <div className="w-full">
          <DatePickerInput
            label="From:"
            name={startDateName ? startDateName : "startDate"}
            onChange={(e) =>
              onChange(startDateName ? startDateName : "startDate", e.target.value)
            }
            value={startDate}
            maxDate={maxDate}
            labelOn={true}
            type="text"
            dateFormat={"LLL dd, YYY"}
            labelDivClass="mb-0"
            labelClass="text-xs text-gray-500"
          />
        </div>
        <div className={classNames(showOneDate ? "hidden" : null, "w-full")}>
          <DatePickerInput
            label="To:"
            name={endDateName ? endDateName : "endDate"}
            onChange={(e) => onChange(endDateName ? endDateName : "endDate", e.target.value)}
            minDate={startDate}
            maxDate={maxDate}
            value={endDate}
            labelOn={true}
            type="text"
            dateFormat={"LLL dd, YYY"}
            labelDivClass="mb-0"
            labelClass="text-xs text-gray-500"
          />
        </div>
      </div>
    </div>
  );
}
